module.exports = {
	"env": "dev",
	"vanityDomain": "https://www.dev-legacy.com",
	"mobileDomain": "https://m.dev-legacy.com",
	"baseUrl": {
		"protocol": "https",
		"hostname": "www.dev-legacy.com",
		"beta": "/beta",
		"pathname": "funeral-homes/obituaries/name",
		"port": ""
	},
	"apiGateway": {
		"protocol": "https",
		"domain": "api-gateway.dev.legint.net",
		"port": ""
	},
	"internalApiGateway": {
		"protocol": "https",
		"domain": "api-gateway.dev.legint.net",
		"port": ""
	},
	"advertising": {
		"environment": "dev"
	},
	"directoryAdvertising": {
		"environment": "dev"
	},
	"statsd": {
		"apiKey": "61e3533c-03ed-43f5-911d-6197a41e4e8e.funeral-home-client.dev",
		"enableLogging": false
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/appConfig/env/dev.json
// module id = 1171
// module chunks = 0